import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { InputComponent } from './input.component';
import { ReactiveFormsModule } from '@angular/forms';
import { NgxMaskModule, IConfig } from 'ngx-mask';
export const options: Partial<IConfig> | (() => Partial<IConfig>) = {};

@NgModule({
  declarations: [InputComponent],
  imports: [CommonModule, ReactiveFormsModule, NgxMaskModule.forRoot(options)],
  exports: [InputComponent, ReactiveFormsModule]
})
export class InputModule {}
